import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RendezvousService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getRendezvousByStatus(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/status-count`);
  }

  getMonthlyRendezvous(): Observable<any> {
    //return this.http.get<any>(`${this.apiUrl}/monthly-count`);
    return this.http.get<any>(`${this.apiUrl}/monthly-count`);
  }

  getMonthlyWeightCollected(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/monthly-weight`);
  }

  getLastThreeMonthsRendezvousCount(): Observable<any[]> {
    //const url = `${this.apiUrl}/monthly-count`;
    const url = `${this.apiUrl}/last-three-months-rendez-vous-count`;
    return this.http.get<any[]>(url);
  }


  getDayWithMostCollections(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/day-with-most-collections`).pipe(
      catchError((error) => {
        return of({ message: 'Erreur lors de la récupération des données' });
      })
    );
  }


  getAverageWeightCollected(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/average-weight-collected`);
  }

  getDailyCollectionsByMonth(): Observable<any> {
    //return this.http.get<any>(`${this.apiUrl}/daily-collections-by-month`);
    return this.http.get<any>(`${this.apiUrl}/daily-collections-by-month`);
  }
}
